export function areEveryFieldsValuesSame<T1 extends {}, T2 extends {} = T1>(obj1: T1, obj2: T2, fields: (keyof (T1 & T2))[]) {
  return fields.every((field) => (obj1[field] === obj2[field]));
}